import React from 'react';
import classNames from 'classnames';
import {
  ColorPalette,
  TitleAlignment,
} from 'screens/addEditCustomScreen/widgetsCardData/imageWidgetCard/types';
import {
  useLocation,
} from 'react-router';
import {
  WidgetProps,
} from './types';
import styles from './styles.module.scss';
import {
  images,
} from '../../../../assets/image';

const ImageWidget: React.FC<WidgetProps> = (props: WidgetProps) => {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const paramLang = queryParams.get('lang');

  const {
    defaultPaddings,
  } = props;

  const getLabelColor = () => {
    const {
      descriptionLabelColor,
    } = props.widgetParams;

    if (descriptionLabelColor === ColorPalette.PRIMARY) {
      return styles.primaryLabel;
    } if (descriptionLabelColor === ColorPalette.ERROR) {
      return styles.errorLabel;
    } if (descriptionLabelColor === ColorPalette.SURFACE) {
      return styles.surfaceLabel;
    }
    return styles.primaryLabel;
  };

  const getTitleColor = () => {
    const {
      titleColor,
      isExternalTitle,
    } = props.widgetParams;

    if (String(isExternalTitle) === 'true') { return; }

    if (titleColor === ColorPalette.PRIMARY) {
      return styles.primaryTitle;
    } if (titleColor === ColorPalette.ERROR) {
      return styles.errorTitle;
    } if (titleColor === ColorPalette.SURFACE) {
      return styles.surfaceTitle;
    }
    return styles.primaryTitle;
  };

  const getInternalTitleClasses = () => {
    const {
      titleAlignment,
      isHorizontalCenter,
    } = props.widgetParams;
    const internalStyles = [styles.internalTitle];
    if (titleAlignment === TitleAlignment.TOP) {
      internalStyles.push(styles.topTitle);
    } else if (titleAlignment === TitleAlignment.CENTER) {
      internalStyles.push(styles.centerTitle);
    } else if (titleAlignment === TitleAlignment.BOTTOM) {
      internalStyles.push(styles.bottomTitle);
    } else {
      internalStyles.push(styles.centerTitle);
    }
    if (`${isHorizontalCenter}` === 'true') {
      internalStyles.push(styles.horizontalCenter);
    }
    return internalStyles;
  };

  return (
    <div className={styles.widgetContainer}>
      <div
        className={classNames([
          styles.imageContainer,
          String(props.widgetParams.isExternalTitle) === 'true' ? styles.externalTitle : getInternalTitleClasses(),
        ])}
      >
        {
          props.widgetParams.descriptionLabel && (
            <div className={classNames([styles.label, getLabelColor(),
              paramLang === 'en' ? styles.enLabel : styles.arLabel,
            ])}>
              <span>{props.widgetParams.descriptionLabel}</span>
            </div>
          )
        }
        <p className={classNames([styles.title, getTitleColor()])}>
          {props.widgetParams.title}
        </p>
        <img
          alt=""
          src={props.widgetParams.imageURL ? props.widgetParams.imageURL : images.placeHolder}
          className={classNames([styles.widgetImage])}
        />
      </div>
      {
        (props.widgetParams.descriptionTitle || props.widgetParams.descriptionSubTitle || props.widgetParams.iconImage) && (
          <div className={classNames([styles.widgetBody])}>
            <img
              src={props.widgetParams.iconImage ? props.widgetParams.iconImage : images.placeHolder}
              className={classNames([styles.iconImage, paramLang === 'en' ? styles.left : styles.right])}
              alt=""
            />
            <h5>{props.widgetParams.descriptionTitle}</h5>
            <h6>{props.widgetParams.descriptionSubTitle}</h6>
          </div>
        )
      }
    </div>
  );
};

export default ImageWidget;
